<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col>
                    <b-btn variant="primary" @click="createTicket"
                        ><i class="fa fa-plus"></i> Crear Ticket</b-btn
                    >
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <app-ticket-list-filters
                        @filter="onFilter"
                    ></app-ticket-list-filters>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <app-ticket-list
                        :table-data="tableData"
                        :on-change-page="onChangePage"
                        @edit="onEdit"
                        @delete="onDelete"
                        @sort="onSort"
                    ></app-ticket-list>
                </b-col>
            </b-row>
            <app-pop-up
                id="ticket-form-window"
                title="Creación de ticket de soporte"
                size="large"
            >
                <template slot="body">
                    <app-ticket-form
                        ref="ticketForm"
                        @ticket-saved-note="onTicketSavedNote"
                        @ticket-saved="onTicketSaved"
                        @ticket-updated="onTicketUpdated"
                        @btn-save-disabled="onBtnDisabled"
                        @btn-save-enabled="onBtnEnable"
                    ></app-ticket-form>
                </template>
                <template slot="buttons">
                    <div v-if="btnSave">
                        <b-btn
                            id="btnSaveTicket"
                            variant="primary"
                            @click="onSaveTicket"
                            :disabled="inProgress"
                            ><i class="fa fa-save"></i> Guardar</b-btn
                        >
                    </div>
                </template>
            </app-pop-up>
        </b-container>
    </div>
</template>
<script>
import TicketListFilters from './TicketListFilters'
import TicketForm from './TicketForm'
import TicketList from './TicketList'
export default {
    data: () => ({
        page: 1,
        filters: null,
        tableData: '',
        sortBy: 'tickets.created_at',
        sortDir: 'desc',
        btnSave: true,
    }),
    components: {
        appTicketForm: TicketForm,
        appTicketListFilters: TicketListFilters,
        appTicketList: TicketList,
    },
    methods: {
        onSaveTicket() {
            this.$refs.ticketForm.saveTicket()
        },
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadTickets()
        },
        async loadTickets() {
            try {
                const params = {
                    ...this.filters,
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                }
                const { data } = await repo.get('tickets', params)
                this.tableData = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onChangePage(page) {
            this.page = page
            this.loadTickets()
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.loadTickets()
        },
        onEdit(ticket) {
            this.$refs.ticketForm.fill(ticket)
            this.$bus.$emit('ticket-form-window.open')
        },
        onDelete(ticket) {
            this.$bvModal
                .msgBoxConfirm('¿Esta seguro de eliminar el Ticket?', {
                    title: 'Confirmación',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Eliminar',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    value && this.deleteTicket(ticket.id)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        async deleteTicket(id) {
            const { data } = await repo.delete('tickets/delete/' + id)
            if (data.status) {
                this.loadTickets()
                toastr.success(data.msg)
            } else {
                toastr.error(data.msg)
            }
        },
        createTicket() {
            this.$refs.ticketForm.reset()
            this.$bus.$emit('ticket-form-window.open')
        },
        onTicketSaved(ticket) {
            this.$bus.$emit('ticket-form-window.close')
            this.loadTickets()
        },
        onTicketSavedNote() {
            this.loadTickets()
        },
        onTicketUpdated(ticket) {
            const index = this.tableData.data.findIndex(
                (item) => item.id === ticket.id
            )
            if (-1 === index) return

            this.tableData.data.splice(index, 1, ticket)
            this.$bus.$emit('ticket-form-window.close')
        },
        onBtnDisabled() {
            this.btnSave = false
        },
        onBtnEnable() {
            this.btnSave = true
        },
    },
    mounted() {
        this.loadTickets()
    },
}
</script>
